// extracted by mini-css-extract-plugin
export default {"empty":"ProjectsEmptyWithContacts_empty__nHoWA","title":"ProjectsEmptyWithContacts_title__CMr+R","text":"ProjectsEmptyWithContacts_text__GIRi9"};